import WhimstayContainerNew from "components/utilities/WhimstayContainerNew";
const ValuePropositionSection = () => {
  return <WhimstayContainerNew className='px-[60px] pb-[10px] pt-[50px] text-center md:px-[150px] md:pb-[60px] md:pt-[90px]' data-sentry-element="WhimstayContainerNew" data-sentry-component="ValuePropositionSection" data-sentry-source-file="ValuePropositionSection.tsx">
      <h2 className='font-wasgaten text-[30px] leading-[1.2] tracking-[-0.015em] text-secondary-500 md:text-[42px]'>
        Explore hundreds of thousands of curated vacation homes across more than
        80 countries
      </h2>

      {/* <p className='mx-auto mt-3.5 text-[15px] leading-[1.5] text-brand-dark md:text-[25px]'>
        Every property is vetted for quality so you can book with confidence for
        your clients.
       </p> */}
    </WhimstayContainerNew>;
};
export default ValuePropositionSection;